module.exports = __webpack_public_path__ + "static/img/lQDPJxtemGwypH_155.3c4b9584.jpg";